import React, { Component } from 'react';
import instance from "./axios-instance";
import jwt_decode from "jwt-decode";
import Systems from "./SystemFunction";
import { toast } from 'react-toastify';
let isMobile = false;
if (window.innerWidth <= 760) isMobile = true;
class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            categorylist: [],
            gamehitlist: [],
            gamenewlist: [],
            listitallgame: [],

            activeProviderIndex: 0,
            activeProvider: null,
            activeFilter: "ALL",
            searchText: "",
            showDropdown: false,
            showGameModal: false,
            selectedGame: null,

            activePage: 1,
            rewardlist: [],
            formData: {},
            errors: {},
            formSubmitted: false,
            loading: false,
            loadingProvider: false,
            loadingGame: false,
            pagecount: 1,
            playerid: null,
            user_id: null,
            point: null,
            products_page_count: 1,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null
        };

        this.handleClick = this.handleClick.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });

        instance
            .get("/api/v1/rewardlist", {
                params: {
                    Cat_ID: 0,
                    page: pageNumber
                }
            })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });
    }

    handleClick = async (e) => {
        this.setState({
            activePage: 1,
            isActive: true,
            activeTab: 0
        });

        instance
            .get("/api/v1/rewardlist", {
                params: {
                    Cat_ID: e.target.id,
                    page: 1
                }
            })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });

        this.setState({
            isActive: false
        });
    };

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    notify = async (mode, msg) => {
        if (mode == "success") {
            await toast.success(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        } else if (mode == "warning") {
            await toast.warning(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        } else if (mode == "error") {
            await toast.error(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        } else if (mode == "info") {
            await toast.info(msg, { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        }
    };

    checklogin() {
        var token = localStorage.getItem('auth_token');

        if (token != null) {
            var decoded = jwt_decode(token);

            this.setState({
                user_id: decoded.message.playerid,
                playerid: decoded.message.member_id,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true
            });
        } else {
            this.setState({
                loginstate: false
            });
        }
    }

    setCache(cacheKey, data, minute = 10) {
        localStorage.setItem(
            cacheKey,
            JSON.stringify({
                timestamp: Date.now(),
                expire: minute * 60 * 1000,
                data: data
            })
        );
    }

    getCache(cacheKey) {
        const cached = localStorage.getItem(cacheKey);

        if (!cached) return null;

        try {
            const parsed = JSON.parse(cached);

            if (parsed && Date.now() - parsed.timestamp < parsed.expire) {
                return parsed.data;
            }

            localStorage.removeItem(cacheKey);
            return null;
        } catch (err) {
            localStorage.removeItem(cacheKey);
            return null;
        }
    }

    async componentDidMount() {
        this.checklogin();
        await this.getSlotPageData();
    }

    async getSlotPageData() {
        await this.getSlotProviderList();
        await this.getHitGames();
        await this.getNewGames();
    }

    async getSlotProviderList() {
        const cacheKey = `slot_provider_state_3_${Systems}`;
        const cachedData = this.getCache(cacheKey);

        const resolveProvider = (categorylist) => {
            const urlCode = (window.location.pathname.split('/')[2] || '').toLowerCase();
            if (urlCode) {
                const idx = categorylist.findIndex(item =>
                    (this.getProviderCode(item) || '').toLowerCase() === urlCode
                );
                if (idx >= 0) return { provider: categorylist[idx], index: idx };
            }
            return { provider: categorylist[0] || null, index: 0 };
        };

        if (cachedData) {
            const categorylist = Array.isArray(cachedData) ? cachedData : [];
            const { provider, index } = resolveProvider(categorylist);

            this.setState({
                categorylist: categorylist,
                activeProvider: provider,
                activeProviderIndex: index
            });

            if (provider) {
                await this.getProviderGames(provider);
            }

            return;
        }

        this.setState({ loadingProvider: true });

        await instance
            .post("/api/v1/tabgamelist", {
                state: "3",
                System: Systems
            })
            .then(async (res) => {
                if (res.data.status === 200) {
                    const categorylist = Array.isArray(res.data.message) ? res.data.message : [];
                    const { provider, index } = resolveProvider(categorylist);

                    this.setCache(cacheKey, categorylist, 180);

                    this.setState({
                        categorylist: categorylist,
                        activeProvider: provider,
                        activeProviderIndex: index
                    });

                    if (provider) {
                        await this.getProviderGames(provider);
                    }
                }
            })
            .catch((err) => {
                console.log("[SLOT_PROVIDER_ERROR]", err);
            })
            .finally(() => {
                this.setState({ loadingProvider: false });
            });
    }

    async getProviderGames(providerItem) {
        const partner = this.getProviderCode(providerItem);

        if (!partner) return;

        await this.getgame("slot", partner, "991");
    }

    async getHitGames() {
        const cacheKey = `slot_hit_state_992_${Systems}`;
        const cachedData = this.getCache(cacheKey);

        if (cachedData) {
            this.setState({
                gamehitlist: Array.isArray(cachedData) ? cachedData : []
            });
            return;
        }

        await instance
            .post("/api/v1/tabgamelist", {
                state: "992",
                System: Systems,
                game: "slot"
            })
            .then((res) => {
                if (res.data.status === 200) {
                    const rows = Array.isArray(res.data.message) ? res.data.message : [];

                    this.setCache(cacheKey, rows, 30);

                    this.setState({
                        gamehitlist: rows
                    });
                }
            })
            .catch((err) => {
                console.log("[SLOT_HIT_ERROR]", err);
            });
    }

    async getNewGames() {
        const cacheKey = `slot_new_state_995_${Systems}`;
        const cachedData = this.getCache(cacheKey);

        if (cachedData) {
            this.setState({
                gamenewlist: Array.isArray(cachedData) ? cachedData : []
            });
            return;
        }

        await instance
            .post("/api/v1/tabgamelist", {
                state: "995",
                System: Systems,
                game: "slot"
            })
            .then((res) => {
                if (res.data.status === 200) {
                    const rows = Array.isArray(res.data.message) ? res.data.message : [];
                    const newlist = rows && rows.length > 0 && Array.isArray(rows[0].newlist) ? rows[0].newlist : [];

                    this.setCache(cacheKey, newlist, 30);

                    this.setState({
                        gamenewlist: newlist
                    });
                }
            })
            .catch((err) => {
                console.log("[SLOT_NEW_ERROR]", err);
            });
    }

    async getgame(typepage, partner, state = "991", cheked = false) {
        if (!partner) return;

        const cacheKey = `tabgamelist_${state}_${Systems}_${partner}_${typepage}`;
        const cachedData = this.getCache(cacheKey);

        if (cachedData) {
            if (cheked) {
                this.setState({
                    listitallgame: Array.isArray(cachedData) ? cachedData : [],
                    providorlist: Array.isArray(cachedData) ? cachedData : []
                });
            } else {
                this.setState({
                    listitallgame: Array.isArray(cachedData) ? cachedData : []
                });
            }
            return;
        }

        this.setState({ loadingGame: true });

        await instance
            .post("/api/v1/tabgamelist", {
                state: state,
                System: Systems,
                partner: partner,
                game: typepage
            })
            .then((res) => {
                if (res.data.status === 200) {
                    const gameData = Array.isArray(res.data.message) ? res.data.message : [];

                    this.setCache(cacheKey, gameData, 10);

                    if (cheked) {
                        this.setState({
                            listitallgame: gameData,
                            providorlist: gameData
                        });
                    } else {
                        this.setState({
                            listitallgame: gameData
                        });
                    }
                }
            })
            .catch((err) => {
                console.log("[GET_SLOT_GAME_ERROR]", err);
            })
            .finally(() => {
                this.setState({ loadingGame: false });
            });
    }

    getProviderName = (item) => {
        return (
            item?.description ||
            item?.Description ||
            item?.proname ||
            item?.providername ||
            item?.ProviderName ||
            item?.name ||
            item?.Name ||
            item?.productname ||
            item?.ProductName ||
            item?.title ||
            item?.Title ||
            item?.game_name ||
            item?.GameName ||
            item?.gamename ||
            "-"
        );
    };

    getProviderCode = (item) => {
        return (
            item?.partner ||
            item?.Partner ||
            item?.providercode ||
            item?.provider_code ||
            item?.ProviderCode ||
            item?.code ||
            item?.Code ||
            item?.key ||
            item?.Key ||
            item?.gameid ||
            item?.gamecode ||
            item?.GameCode ||
            ""
        );
    };

getProviderImage = (item) => {
    return (
        item?.imagesec ||
        ""
    );
};
redeem = async (e, gameIdx, partner) => {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }

    var userAgent = navigator.userAgent;

    await this.checklogin();

    if (!this.state.loginstate) {
        await this.notify("error", "คุณยังไม่ได้เข้าสู่ระบบ");
        return;
    }

    const username = this.state.username || this.state.user_id || this.state.playerid;

    if (!username) {
        await this.notify("error", "ไม่พบข้อมูลผู้เล่น กรุณาเข้าสู่ระบบใหม่");
        return;
    }

    if (!gameIdx || !partner) {
        await this.notify("error", "ไม่พบข้อมูลเกม กรุณาลองใหม่");
        return;
    }

    await instance
        .post("/api/v1/tablauncher", {
            gameId: gameIdx,
            partner: partner,
            playerUsername: username,
            isMobile: isMobile,
            System: Systems,
            demo: false
        })
        .then((res) => {
            if (res.data.status === 200) {
                var launcher = res.data.message.launcher;

                if (launcher !== undefined) {
                    if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                        window.location.href = launcher.mobile;
                    } else {
                        if (!isMobile) {
                            window.open(launcher.desktop, "_blank", "height=1000,width=1000");
                        } else {
                            window.open(launcher.mobile);
                        }
                    }
                } else {
                    this.notify("error", "ขณะนี้เกมมีปัญหากรุณารอซักครู่");
                }
            } else {
                this.notify("error", res.data.message || "เปิดเกมไม่สำเร็จ");
            }
        })
        .catch((err) => {
            console.error("[LAUNCH_GAME_ERROR]", err);
            this.notify("error", "ขณะนี้เกมมีปัญหากรุณารอซักครู่");
        });
};

redeemdemo = async (e, gameIdx, partner) => {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }

    var userAgent = navigator.userAgent;

    if (!gameIdx || !partner) {
        await this.notify("error", "ไม่พบข้อมูลเกม กรุณาลองใหม่");
        return;
    }

    await instance
        .post("/api/v1/tablauncher", {
            gameId: gameIdx,
            partner: partner,
            playerUsername: this.state.username || this.state.user_id || this.state.playerid || "demo",
            isMobile: isMobile,
            System: Systems,
            demo: true
        })
        .then((res) => {
            if (res.data.status === 200) {
                var launcher = res.data.message.launcher;

                if (launcher !== undefined) {
                    if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
                        window.location.href = launcher.mobile;
                    } else {
                        if (!isMobile) {
                            window.open(launcher.desktop || launcher.mobile, "_blank", "height=1000,width=1000");
                        } else {
                            window.open(launcher.mobile || launcher.desktop);
                        }
                    }
                } else {
                    this.notify("error", "ขณะนี้เกมมีปัญหากรุณารอซักครู่");
                }
            } else {
                this.notify("error", res.data.message || "เปิดเกมเดโมไม่สำเร็จ");
            }
        })
        .catch((err) => {
            console.log("[LAUNCH_DEMO_GAME_ERROR]", err);
            this.notify("error", "ขณะนี้เกมเดโมมีปัญหากรุณารอซักครู่");
        });
};
getGameImage = (item) => {
    return (
        item?.image ||
        item?.imgprovidor ||
        item?.imagesec ||
        item?.selectimg ||
        item?.Image ||
        item?.img ||
        item?.img_path ||
        item?.imagepath ||
        item?.picture ||
        ""
    );
};

    getGameType = (item) => {
        const raw = (
            item?.proname ||
            item?.providername ||
            item?.ProviderName ||
            item?.partner ||
            item?.game_provider ||
            item?.provider ||
            item?.type ||
            item?.Type ||
            item?.category ||
            ""
        );
        const nameMap = {
            'PRAGMATIC_SLOT': 'Pragmatic Play',
            'PRAGMATIC': 'Pragmatic Play',
            'PP': 'Pragmatic Play',
            'NEXTSPIN': 'Nextspin',
            'PGSOFT': 'PG Soft',
            'PG': 'PG Soft',
            'JOKER': 'Joker Gaming',
            'JILI': 'JILI',
            'SPADEGAMING': 'Spade Gaming',
            'NETENT': 'NetEnt',
            'PLAYTECH': 'Playtech',
            'MICROGAMING': 'Microgaming',
            'EVOPLAY': 'Evoplay',
            'HABANERO': 'Habanero',
            'REDTIGER': 'Red Tiger',
            'NOLIMITCITY': 'No Limit City',
            'HACKSAW': 'Hacksaw Gaming',
            'YGGDRASIL': 'Yggdrasil',
            'BTGSOFTWARE': 'BTG',
            'RELAXGAMING': 'Relax Gaming',
        };
        return nameMap[raw?.toUpperCase?.()] || raw;
    };

    getRtp = (item) => {
        return item?.rtp || item?.RTP || item?.percent || item?.Percent || "";
    };

    // สุ่ม RTP 85.00–97.00 ต่อ gameId, cache 10 นาที
    getDisplayRtp = (item) => {
        // ถ้า server มีค่าจริงให้ใช้เลย
        const real = this.getRtp(item);
        if (real) return real;

        const gameId = item?.gameid || item?.gameId || item?.game_id || item?.code || item?.Code || '';
        if (!gameId) return '';

        const CACHE_KEY  = `rtp_cache_${Systems}`;
        const EXPIRE_MS  = 10 * 60 * 1000; // 10 นาที
        const now        = Date.now();

        let store = {};
        try { store = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}'); } catch (_) {}

        const entry = store[gameId];
        if (entry && now - entry.t < EXPIRE_MS) {
            return entry.v;
        }

        // สุ่มใหม่ 85.00–97.00 ทศนิยม 2 ตำแหน่ง
        const rtp = (Math.random() * (97 - 85) + 85).toFixed(2) + '%';

        // ถ้า cache หมดอายุทั้งหมด ล้างก่อนเพื่อไม่ให้ localStorage บวม
        const hasExpired = Object.values(store).some(e => now - e.t >= EXPIRE_MS);
        if (hasExpired) {
            store = {};
        }

        store[gameId] = { v: rtp, t: now };
        try { localStorage.setItem(CACHE_KEY, JSON.stringify(store)); } catch (_) {}

        return rtp;
    };

    getGameCategory = (item) => {
        return (
            item?.categories ||
            item?.category ||
            item?.Category ||
            item?.gamecategory ||
            item?.game_category ||
            item?.type ||
            item?.Type ||
            "HTML5"
        );
    };

    selectProvider = async (item, index) => {
        this.setState({
            activeProvider: item,
            activeProviderIndex: index,
            activeFilter: "ALL",
            searchText: "",
            listitallgame: []
        });

        await this.getProviderGames(item);
    };

    selectProviderByDropdown = async (provider, index) => {
        const code = this.getProviderCode(provider);
        window.history.pushState(null, '', `/slot/${code}`);
        this.setState({ activeProvider: provider, activeProviderIndex: index, showDropdown: false });
        await this.getProviderGames(provider);
    };

    setFilter = (filter) => {
        this.setState({
            activeFilter: filter
        });
    };

    handleSearchChange = (e) => {
        this.setState({
            searchText: e.target.value
        });
    };

    setFilter = (code) => {
        this.setState({ activeFilter: code });
    };

    getActiveGameRows = () => {
        const { activeFilter, listitallgame, gamehitlist, gamenewlist, searchText } = this.state;

        let rows = [];

        if (activeFilter === "HIT") {
            rows = Array.isArray(gamehitlist) ? gamehitlist : [];
        } else if (activeFilter === "NEW") {
            rows = Array.isArray(gamenewlist) ? gamenewlist : [];
        } else {
            rows = Array.isArray(listitallgame) ? listitallgame : [];
        }

        if (activeFilter === "SLOT") {
            rows = rows.filter((item) => String(this.getGameCategory(item)).toLowerCase().includes("slot"));
        }

        if (activeFilter === "ARCADE") {
            rows = rows.filter((item) => String(this.getGameCategory(item)).toLowerCase().includes("arcade"));
        }

        if (searchText && searchText.trim() !== "") {
            const keyword = searchText.trim().toLowerCase();

            rows = rows.filter((item) => {
                const name = this.getProviderName(item).toLowerCase();
                const code = this.getProviderCode(item).toLowerCase();
                const type = this.getGameType(item).toLowerCase();

                return name.includes(keyword) || code.includes(keyword) || type.includes(keyword);
            });
        }

        return rows;
    };

    renderInfoIcon() {
        return (
            <div className="icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" className="" width="100%" height="100%">
                    <g className="D-referral-important">
                        <path d="M45,0C20.1,0,0,20.1,0,45c0,24.9,20.1,45,45,45c24.9,0,45-20.1,45-45C90,20.1,69.9,0,45,0z M50.6,70.9 c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6V36.2c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6V70.9z M45,24.7c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6C50.6,22.2,48.1,24.7,45,24.7z" />
                    </g>
                </svg>
            </div>
        );
    }

    renderSearchIcon() {
        return (
            <div className="icon-sm">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.13323 19.00913" className="beta-search" width="100%" height="100%">
                    <g className="beta-search">
                        <path d="M17.84436,17.32399l-4.091-4.09131c1.33264-1.45972,2.07007-3.33203,2.07007-5.32227c0-2.11328-0.823-4.1001-2.31726-5.59375c-1.49323-1.49426-3.48004-2.31714-5.59442-2.31714c-2.11432,0-4.10144,0.82288-5.59436,2.31689c-1.49463,1.4939-2.31763,3.48071-2.31763,5.59399c0,2.11401,0.823,4.10107,2.31726,5.59473c1.49359,1.49438,3.48071,2.31726,5.59473,2.31726c1.56732,0,3.06348-0.45447,4.34167-1.29724l4.19476,4.19507c0.38538,0.38538,1.01184,0.38599,1.39685,0.00098C18.22973,18.33619,18.22973,17.70948,17.84436,17.32399z M3.28699,12.53517c-1.23547-1.23438-1.91583-2.87695-1.91583-4.62476c0-1.74707,0.68036-3.38928,1.91614-4.62402c1.23413-1.23511,2.8764-1.91553,4.62445-1.91553c1.74774,0,3.39001,0.68042,4.62445,1.91577c1.23547,1.2345,1.91583,2.87671,1.91583,4.62378c0,1.7478-0.68036,3.39038-1.91614,4.62512c-1.23444,1.23523-2.87671,1.91541-4.62415,1.91541C6.16406,14.45094,4.52179,13.77076,3.28699,12.53517z" />
                    </g>
                </svg>
            </div>
        );
    }

   renderTopGameCard = (game, index) => {
    const name = this.getProviderName(game);
    const img = this.getGameImage(game);
    const type = this.getGameType(game);
    const rtp = this.getDisplayRtp(game);
    const partner = game?.partner || game?.Partner || game?.providercode || game?.ProviderCode || "";
    const gameId = game?.gameid || game?.gameId || game?.game_id || game?.code || game?.Code || this.getProviderCode(game);

    return (
        <div className="hot-game-container" key={`${partner}-${gameId}-${index}`} onClick={() => this.openGameModal(game)}>
            <div className="hot-game-img-warpper">
                <img loading="lazy" src={img} alt={name} />

                {index < 2 ? <div className="hot-icon">ฮอต</div> : <div className="new-icon">ใหม่</div>}

                <div className="btn-container">
                    <button
                        type="button"
                        aria-label="launch-game"
                        className="top-game-play-btn"
                        onClick={(e) => { e.stopPropagation(); this.openGameModal(game); }}
                    >
                        เล่น
                    </button>
                </div>
            </div>

            <div className="hot-game-content">
                <div className="row-1">
                    <p className="game-name">{name}</p>
                    {this.renderInfoIcon()}
                </div>

                <p className="game-type">{type}</p>

                {rtp ? (
                    <p className="game-rtp">
                        RTP <span>{rtp}</span>
                    </p>
                ) : null}
            </div>
        </div>
    );
};

    renderProviderItem = (item, index) => {
        const name = this.getProviderName(item);
        const code = this.getProviderCode(item);
        const img = this.getProviderImage(item);
        const isActive = this.state.activeProviderIndex === index;

        return (
            <div
                key={`${code || name}-${index}`}
                className={`tab-header ${isActive ? "active" : "false"}`}
                data-provider-name={name}
                data-provider-code={code}
                onClick={() => this.selectProvider(item, index)}
            >
                {index === 0 ? <p className="float-dot hot-provider">ฮอต</p> : null}

                <div className="tab-inner">
                    {img ? (
                        <img src={img} alt={name} style={{ width: 20, height: 20,marginRight: 8, objectFit: "contain" }} />
                    ) : (
                        <span style={{ width: 20, height: 20, display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 12 }}>
                            {name}
                        </span>
                    )}

                    <span>{name}</span>
                </div>
            </div>
        );
    };

    renderFilterHeader = (code, text) => {
        const isActive = this.state.activeFilter === code;

        return (
            <div
                className={`filter-header ${isActive ? "active" : ""}`}
                data-game-category-name={code}
                data-game-category-code={code}
                onClick={() => this.setFilter(code)}
            >
                <span className="text">{text}</span>
            </div>
        );
    };

   renderGameCard = (game, index) => {
    const name = this.getProviderName(game);
    const code = this.getProviderCode(game);
    const img = this.getGameImage(game);
    const rtp = this.getDisplayRtp(game);
    const partner = game?.partner || game?.Partner || game?.providercode || game?.ProviderCode || "";
    const gameId = game?.gameid || game?.gameId || game?.game_id || game?.code || game?.Code || code;

    return (
        <div className="item-col" key={`${partner}-${gameId}-${index}`}>
            <div className="game-box" onClick={() => this.openGameModal(game)}>
                <div
                    className="game-img-wrapper"
                    data-game-name={name}
                    data-game-code={gameId}
                >
                    <img loading="lazy" src={img} alt={name} />

                    {/* BK8-style hover overlay */}
                    <div className="game-hover-overlay">
                        <p className="game-hover-name">{name}</p>
                        <button
                            className="game-hover-btn play"
                            onClick={(e) => { e.stopPropagation(); this.redeem(e, gameId, partner); }}
                        >
                            เล่น
                        </button>
                        <button
                            className="game-hover-btn demo"
                            onClick={(e) => { e.stopPropagation(); this.redeemdemo(e, gameId, partner); }}
                        >
                            ทดลองเล่น
                        </button>
                    </div>
                </div>

                <div className="game-details">
                    <div className="game-name-info">
                        <p className="game-name">{name}</p>
                    </div>
                    <div className="game-others-info">
                        <p className="game-rtp">RTP <span>{rtp || '-'}</span></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

    openGameModal = (game) => {
        this.setState({ selectedGame: game, showGameModal: true });
    };

    closeGameModal = () => {
        this.setState({ selectedGame: null, showGameModal: false });
    };

    renderGameModal = () => {
        const { showGameModal, selectedGame } = this.state;
        if (!showGameModal || !selectedGame) return null;

        const name    = this.getProviderName(selectedGame);
        const img     = this.getGameImage(selectedGame);
        const gameId  = this.getGameCode ? this.getGameCode(selectedGame) : (selectedGame?.gameid || selectedGame?.gameId || selectedGame?.code || '');
        const partner = selectedGame?.partner || selectedGame?.Partner || selectedGame?.providercode || selectedGame?.ProviderCode || '';
        const rtp     = this.getDisplayRtp(selectedGame);
        const type    = this.getGameType ? this.getGameType(selectedGame) : '';

        return (
            <div className="ReactModalPortal">
                <div
                    className="ReactModal__Overlay ReactModal__Overlay--after-open standard-popup-overlay"
                    onClick={this.closeGameModal}
                >
                    <div
                        className="ReactModal__Content ReactModal__Content--after-open standard-popup-modal-container game-popup-modal-container"
                        tabIndex="-1"
                        role="dialog"
                        aria-modal="true"
                        onClick={e => e.stopPropagation()}
                    >
                        {/* Header — close button */}
                        <div style={{ display:'flex', justifyContent:'flex-end', padding:'10px 12px 4px' }}>
                            <div
                                className="standard-modal-close"
                                onClick={this.closeGameModal}
                                style={{ width:18, height:18, cursor:'pointer', flexShrink:0 }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.81858 8.81858" width="100%" height="100%">
                                    <g><g><g>
                                        <path fill="#555" d="M0.26095,8.81701c-0.06982,0-0.13379-0.02734-0.18506-0.07715C-0.01541,8.64806-0.0203,8.4879,0.06857,8.38732l8.3042-8.30566c0.05273-0.05371,0.11426-0.08008,0.18555-0.08008c0.07031,0,0.13477,0.02734,0.18555,0.07813c0.09961,0.10059,0.10059,0.2666-0.00098,0.36719l-8.354,8.3457C0.38449,8.79162,0.33029,8.81701,0.26095,8.81701z"/>
                                        <path fill="#555" d="M8.55832,8.81701c-0.07324,0-0.1377-0.02637-0.18555-0.07422L0.02756,0.38927C-0.0159,0.33849-0.0159,0.17443,0.08224,0.0758c0.0459-0.0459,0.10986-0.07227,0.17871-0.07227c0.06348,0,0.12158,0.02148,0.16309,0.05859l8.31592,8.31055c0.05078,0.0498,0.07715,0.11328,0.07715,0.18457c0,0.07227-0.02637,0.13574-0.0752,0.18457S8.62961,8.81701,8.55832,8.81701z"/>
                                    </g></g></g>
                                </svg>
                            </div>
                        </div>

                        {/* Body */}
                        <div className="standard-popup-modal-body game-popup-modal-body">
                            <div className="top-container">
                                <div className="game-image-container">
                                    <img loading="lazy" src={img} className="game-image" alt={name} />
                                </div>
                                <div className="game-info-container">
                                    <div className="game-name">{name}</div>
                                    <div className="provider-name">{type}</div>
                                    <div className="short-row rtp-row">
                                        <div className="title">RTP</div>
                                        <div className="value">{rtp || '-'}</div>
                                    </div>
                                    <div className="short-row line-row">
                                        <div className="title">Line</div>
                                        <div className="value">-</div>
                                    </div>
                                </div>
                            </div>
                            <div className="long-row volatility-row">
                                <div className="title">การเปลี่ยนแปลง</div>
                                <div className="value">-</div>
                            </div>
                            <div className="long-row win-row">
                                <div className="title">อัตราการชนะ</div>
                                <div className="value">-</div>
                            </div>
                            <div className="standard-button-container">
                                <button
                                    className="play-btn"
                                    data-button-category="play"
                                    type="button"
                                    onClick={(e) => { this.closeGameModal(); this.redeem(e, gameId, partner); }}
                                >
                                    <span>เล่น</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const isMobile = window.innerWidth <= 760;
        const { categorylist, gamehitlist, loadingGame, searchText } = this.state;
        const games = this.getActiveGameRows();

        /* ─── MOBILE LAYOUT ─── */
        if (isMobile) {
            const { activeProvider, showDropdown, categorylist } = this.state;
            const providerName = activeProvider ? this.getProviderName(activeProvider) : 'สล็อต';
            const providerImg  = activeProvider ? this.getProviderImage(activeProvider) : '';
            const providerCode = activeProvider ? this.getProviderCode(activeProvider) : '';

            return (
                <div className="slots-mobile-wrapper">
                    {this.renderGameModal()}

                    {/* ── BK8-style nav header ── */}
                    <nav className="mobile-nav header-grey">
                        <div className="col-left">
                            <svg
                                className="menu-icon beta-back"
                                onClick={() => window.history.back()}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24" height="24"
                                fill="currentColor"
                            >
                                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                            </svg>
                            {activeProvider && (
                                <div className={`provider-icon C-${providerCode}`}>
                                    {providerImg
                                        ? <img src={providerImg} alt={providerName} />
                                        : <span>{providerName.slice(0, 2)}</span>
                                    }
                                </div>
                            )}
                        </div>
                        <div className="col-right">
                            <div>
                                <div
                                    id="dropdownBtn"
                                    className={`standard-select${showDropdown ? ' isOpen' : ''}`}
                                    onClick={() => this.setState({ showDropdown: !showDropdown })}
                                >
                                    <span className="nav-title">{providerName}</span>
                                    <span className="standard-select-arrow"></span>
                                </div>
                            </div>
                        </div>
                    </nav>

                    {/* ── Provider dropdown overlay ── */}
                    {showDropdown && (
                        <div
                            className="casino-mobile-provider-overlay"
                            onClick={() => this.setState({ showDropdown: false })}
                        >
                            <div
                                className="casino-mobile-provider-dropdown-list"
                                onClick={e => e.stopPropagation()}
                            >
                                {categorylist.map((p, idx) => {
                                    const name = this.getProviderName(p);
                                    const code = this.getProviderCode(p);
                                    const img  = this.getProviderImage(p);
                                    const isActive = this.state.activeProviderIndex === idx;
                                    return (
                                        <div
                                            key={`dd-${code}-${idx}`}
                                            className={`casino-mobile-dd-item${isActive ? ' active' : ''}`}
                                            onClick={() => this.selectProviderByDropdown(p, idx)}
                                        >
                                            <div className="casino-mobile-dd-logo">
                                                {img
                                                    ? <img src={img} alt={name} />
                                                    : <span>{name.slice(0, 2)}</span>
                                                }
                                            </div>
                                            <span className="casino-mobile-dd-name">{name}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* ── Hot games: title + 3-col grid ── */}
                    {gamehitlist.length > 0 && (
                        <div className="slots-mobile-hot">
                            <p className="slots-mobile-hot-title">เกมยอดนิยม</p>
                            <div className="slots-mobile-hot-grid">
                                {gamehitlist.slice(0, 6).map((game, index) =>
                                    this.renderTopGameCard(game, index)
                                )}
                            </div>
                        </div>
                    )}

                    {/* ── Sort + Search bar ── */}
                    <div className="slots-mobile-sort-bar">
                        <div className="slots-mobile-sort-btn">
                            <span>เป็นที่นิยม</span>
                            <span className="slots-mobile-sort-chevron">&#8964;</span>
                        </div>
                        <div className="slots-mobile-search">
                            {this.renderSearchIcon()}
                            <input
                                type="text"
                                className="search-input"
                                placeholder="ค้นหา"
                                value={searchText}
                                onChange={this.handleSearchChange}
                            />
                        </div>
                    </div>

                    {/* ── Filter tabs ── */}
                    <div className="slots-mobile-filters">
                        {this.renderFilterHeader("ALL", "เกมทั้งหมด")}
                        {this.renderFilterHeader("HIT", "เกมยอดฮิต")}
                        {this.renderFilterHeader("NEW", "เกมใหม่")}
                        {this.renderFilterHeader("SLOT", "Slot")}
                        {this.renderFilterHeader("ARCADE", "Arcade")}
                    </div>

                    {/* ── Game grid 3 columns ── */}
                    <div className="slots-mobile-game-grid">
                        {loadingGame ? (
                            <p className="slots-mobile-loading">กำลังโหลดเกม...</p>
                        ) : games.length > 0 ? (
                            games.map((game, index) => this.renderGameCard(game, index))
                        ) : (
                            <p className="slots-mobile-loading">ไม่พบเกม</p>
                        )}
                    </div>

                </div>
            );
        }

        /* ─── DESKTOP LAYOUT ─── */
        return (
            <>
                {this.renderGameModal()}
                <div className="providerLandingIndexContainer slots-container">
                    <div className="top top-provider-img">
                        <div className="_productBannerContainer_1ma75_1 product-banner-container">
                            <div className="slick-slider slider slick-initialized">
                                <div className="slick-list">
                                    <div className="slick-track" style={{ width: "100%", opacity: 1, transform: "translate3d(0px, 0px, 0px)" }}>
                                        <div data-index={0} className="slick-slide slick-active slick-current" tabIndex={-1} aria-hidden="false" style={{ outline: "none", width: "100%" }}>
                                            <div>
                                                <div className="_productBannerWrapper_1ma75_1 top top-provider-img" tabIndex={-1} style={{ width: "100%", display: "inline-block" }}>
                                                    <img
                                                        loading="lazy"
                                                        src="https://s3.newworld.center/image/c83a0811-4850-4081-9b2d-71d3bff454da.webp"
                                                        className="_productBanner_1ma75_1 provider-banner"
                                                        alt="banner-img"
                                                    />

                                                    <div className="_content_1ma75_25 top-provider-content">
                                                        <p className="_title_1ma75_48 provider-type">สล็อต</p>

                                                        <div className="_desc_1ma75_58 provider-desc">
                                                            <h3><span style={{ lineHeight: "107%" }}><span lang="TH">เกมคือพรหมลิขิตของเรา</span></span></h3>
                                                            <h4><span style={{ lineHeight: "107%" }}><span lang="TH">ลงทะเบียนวันนี้เพื่อรับรางวัลใหญ่</span></span></h4>
                                                        </div>
                                                    </div>

                                                    <div className="bk8-logo-container">
                                                        <div className="logo-img" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="top-games-container">
                        <p className="hot-game-title">เกมยอดนิยม</p>

                        <div className="top-games-content-wrapper">
                            {gamehitlist.length > 0 ? (
                                gamehitlist.slice(0, 5).map((game, index) => this.renderTopGameCard(game, index))
                            ) : (
                                <div className="hot-game-container">
                                    <div className="hot-game-content">
                                        <div className="row-1">
                                            <p className="game-name">กำลังโหลดเกมยอดนิยม</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="mid" id="provider-box">
                        <li className="provider-box">
                            {categorylist.length > 0 ? (
                                categorylist.map((item, index) => this.renderProviderItem(item, index))
                            ) : (
                                <div className="tab-header active" data-provider-name="Loading" data-provider-code="LOADING">
                                    <p className="float-dot hot-provider">ฮอต</p>
                                    <div className="tab-inner">
                                        <span>กำลังโหลดค่ายเกม</span>
                                    </div>
                                </div>
                            )}
                        </li>
                    </div>

                    <div className="bottom">
                        <div className="filter-container">
                            <div className="filter-list">
                                {this.renderFilterHeader("ALL", "เกมทั้งหมด")}
                                {this.renderFilterHeader("HIT", "เกมยอดฮิต")}
                                {this.renderFilterHeader("NEW", "เกมใหม่")}
                                {this.renderFilterHeader("SLOT", "Slot")}
                                {this.renderFilterHeader("ARCADE", "Arcade")}
                            </div>

                            <div className="sort-container">
                                <p className="sort-title">เรียงโดย</p>

                                <div className="sort-type-container">
                                    <div id="dropdownBtn" className="sort-type-wrapper">
                                        <p className="sort-type-title">เป็นที่นิยม</p>
                                    </div>
                                </div>

                                <div className="search-web">
                                    {this.renderSearchIcon()}
                                    <input
                                        type="text"
                                        id="search-input"
                                        className="search-input"
                                        placeholder="ค้นหา"
                                        value={searchText}
                                        onChange={this.handleSearchChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="content-container">
                            {loadingGame ? (
                                <div className="item-col">
                                    <div className="game-box">
                                        <div className="game-details">
                                            <div className="row-1">
                                                <p className="game-name">กำลังโหลดเกม...</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : games.length > 0 ? (
                                games.map((game, index) => this.renderGameCard(game, index))
                            ) : (
                                <div className="item-col">
                                    <div className="game-box">
                                        <div className="game-details">
                                            <div className="row-1">
                                                <p className="game-name">ไม่พบเกม</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default App;